import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsAuthImagePipe } from './is-auth-image.pipe';

@NgModule({
  declarations: [IsAuthImagePipe],
  imports: [CommonModule],
  exports: [IsAuthImagePipe]
})
export class IsAuthImagePipeModule {}
